import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import CheckboxField from '@grnhse/seedling/lib/birch/components/forms/fields/checkbox_field';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.filter_row.previously_rejected');

export const PreviouslyRejectedContent = () => {
  return (
    <Stack spacing={2} direction="column">
      <CheckboxField
        name="excludePreviouslyRejected"
        label={t('checkbox_label')}
        value="excludePreviouslyRejected"
      />
    </Stack>
  );
};
